<template>
    <div id="contact-form-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <img class="side-img d-none d-md-block" src="/images/lakeside.png" alt="Luxury dock on the lake">
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="modal-content-right">
                                <div class="modal-header">
                                    <h2 ref="modal-title" class="modal-title">We will contact you!</h2>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <img src="/images/modal_btn_close.svg" alt="Close button image">
                                    </button>
                                </div>
                                <div class="separator"></div>
                                <form ref="contact-form" @submit.prevent="postContactForm">
                                    <div class="form-group">
                                        <label for="passion">What's your passion?</label>
                                        <select class="form-control dropdown lead-in-section-link" v-model="form.passion" name="passion" id="passion" required>
                                            <option>Vacation Properties</option>
                                            <option>Custom Homeowners</option>
                                            <option>Collector Vehicles</option>
                                            <option>Valuable Articles (jewellery, wine, road bikes)</option>
                                            <option>Umbrella/Excess Liability Policies (Canada/US)</option>
                                            <option>US Properties for Snowbirds</option>
                                            <option>Insuring your Renovation</option>
                                            <option>Insuring your New Build (Course of Construction/Builder’s Risk)</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="d-flex justify-content-between" for="name">What is your full name?</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" v-model="form.name" name="name" ref="name" id="name" placeholder="First &amp; Last Name" >
                                        <has-error :form="form" field="name"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="d-flex justify-content-between" for="phone_number">Phone number</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.has('phone_number') }"  v-model="form.phone_number" name="phone_number" ref="phone" id="phone_number" placeholder="705-555-1234" >
                                        <has-error :form="form" field="phone_number"></has-error>

                                    </div>
                                    <div class="form-group">
                                        <label for="time">The best time to contact me is...</label>
                                        <select class="form-control dropdown" v-model="form.time" name="time" id="time" required>
                                            <option>Anytime</option>
                                            <option>Morning</option>
                                            <option>Afternoon</option>
                                            <option>Evening</option>
                                            <option>Weekends</option>
                                        </select>
                                    </div>
                                    <button type="submit" class="btn btn-primary">Submit</button>
                                </form>
                                <p ref="submit-response" class="submit-response" style="display: none;">We will contact you shortly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form, HasError, AlertError } from 'vform';

    Vue.component(HasError.name, HasError);

    export default {
        data(){
           return {
                form: new Form({
                    passion: 'Vacation Properties',
                    name: '',
                    phone_number: '',
                    time: "Anytime",
                })
           }
       },
       methods: {
           updatePassion(passion) {
               this.form.passion = passion;
           },
           postContactForm(){
               this.form.post('/api/contact', {
                    ...this.form,
                })
                .then((response) => {
                    // switch form to flash message
                    this.submitResponse();
                    this.clearForm();

                });
           },
           clearForm(){
               this.form = new Form({
                    passion: 'Vacation Properties',
                    name: '',
                    phone_number: '',
                    time: "Anytime",
                });
           },
           submitResponse(){
               this.$refs['modal-title'].innerText = 'Thank you!'
               this.$refs['contact-form'].style.display = "none";
               this.$refs['submit-response'].style.display = "block";
           },
       }
    }
</script>
